import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/login';
import Playground from './pages/playground';
import DisplayBook from './pages/display_book';
import PrivateRoute from './routers/privateRoute';
import { useUserStore } from './utils/userStore';
import MainLayout from './layouts/general-layout';
import { ROUTERS_PATH } from './routers/routers';
import './i18n';

function App() {
  const setUserInfo = useUserStore((state) => state.setUserInfo);
  const setAttributes = useUserStore((state) => state.setAttributes);

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path={ROUTERS_PATH.LOGIN} element={<LoginPage />} />
          <Route path={ROUTERS_PATH.DISPLAY_BOOK} element={<DisplayBook />} />

          <Route element={<PrivateRoute />}>
            <Route path={ROUTERS_PATH.PLAYGROUND} element={<Playground />} />
          </Route>

          <Route path="*" element={<Navigate to={ROUTERS_PATH.LOGIN} />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
